import { Flex } from "flicket-ui";
import { useRouter } from "next/router";
import { Menu, Status } from "~components";
import { useShowHeaderBanner } from "~components/common/common.HeaderAlertBanner";
import { useFacebookPixelScripts } from "~features/analytics/useThirdpartyScripts";
import { Detail } from "~features/events/components/EventDetails/EventDetails";
import { useCampaignReportingOpen } from "~hooks/useBroadastCampaignReporting";
import { useEventAccessControl } from "~hooks/useEventAccessControl";
import { useEventTrackingCodes } from "~hooks/useEventTrackingCodes";
import { useGoogleAnalyticsPageView } from "~hooks/useGoogleAnalytics";

const EventInfoPage = () => {
  const router = useRouter();

  const {
    isLoading,
    event,
    error,
    release,
    accessType,
  } = useEventAccessControl();

  useCampaignReportingOpen(!isLoading);
  useGoogleAnalyticsPageView(router.query.eventId as string);
  useEventTrackingCodes();

  useFacebookPixelScripts(event?.pixelId);

  return (
    <>
      <Menu />
      <Status loading={isLoading} error={error}>
        <Detail accessType={accessType} event={event} release={release} />
      </Status>
    </>
  );
};

export default EventInfoPage;
